<template>
  <div class="field">
    <div class="control">
      <input
      type="checkbox"
      :checked="checked"
      @click="$emit('toggle')">
    </div>
  </div>
</template>

<script>
export default {
  props: {
    checked: {
      type: Boolean,
      default: false
    }
  }
}
</script>
